import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import AuthLayout from "@/components/AuthLayout";
import { api, formatError } from "@/lib/api";

export default function ForgotPassword() {
  const [stage, setStage] = useState("request");
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);

  const request = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      toast.success("Reset code sent");
      if (data.dev_code) { setCode(data.dev_code); toast.message(`Demo code: ${data.dev_code}`); }
      setStage("reset");
    } catch (e2) { toast.error(formatError(e2.response?.data?.detail)); }
    setLoading(false);
  };

  const reset = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { email, code, new_password: pw });
      toast.success("Password updated — you can sign in now");
      setStage("done");
    } catch (e2) { toast.error(formatError(e2.response?.data?.detail)); }
    setLoading(false);
  };

  return (
    <AuthLayout title="Reset your password" subtitle="We'll email you a 6-digit code."
      footer={<span>Remembered it? <Link to="/login" className="font-semibold text-brand hover:underline">Back to sign in</Link></span>}>
      {stage === "request" && (
        <form onSubmit={request} className="space-y-4">
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" required data-testid="forgot-email"
            className="w-full rounded-md border border-line bg-white px-3.5 py-2.5 text-sm outline-none focus:border-brand" />
          <button disabled={loading} data-testid="forgot-submit"
            className="flex w-full items-center justify-center gap-2 rounded-md bg-brand py-2.5 text-sm font-semibold text-white hover:bg-brand-dark disabled:opacity-60">
            {loading && <Loader2 className="h-4 w-4 animate-spin" />} Send code
          </button>
        </form>
      )}
      {stage === "reset" && (
        <form onSubmit={reset} className="space-y-4">
          <input value={code} onChange={(e) => setCode(e.target.value)} placeholder="6-digit code" required data-testid="reset-code"
            className="w-full rounded-md border border-line bg-white px-3.5 py-2.5 text-sm outline-none focus:border-brand" />
          <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="New password" required minLength={6} data-testid="reset-password"
            className="w-full rounded-md border border-line bg-white px-3.5 py-2.5 text-sm outline-none focus:border-brand" />
          <button disabled={loading} data-testid="reset-submit"
            className="flex w-full items-center justify-center gap-2 rounded-md bg-brand py-2.5 text-sm font-semibold text-white hover:bg-brand-dark disabled:opacity-60">
            {loading && <Loader2 className="h-4 w-4 animate-spin" />} Update password
          </button>
        </form>
      )}
      {stage === "done" && (
        <div className="rounded-md bg-brand-wash p-4 text-sm text-brand-dark">
          Password updated. <Link to="/login" className="font-semibold underline">Sign in now →</Link>
        </div>
      )}
    </AuthLayout>
  );
}
